import { Box, Typography, TextField, FormControl, MenuItem } from "@mui/material";
import { TFunction, i18n } from "next-i18next";
import { FC, memo } from "react";
import { formikForMySelect, formikForTextField } from "@/com_lib/formik_helper";
import { MySelect, TextFieldNoLabelProps, getSelectOptions } from "../Common";
import { country } from "@prisma/client";
import generalStyle from '@/components/general.module.scss';
import { getLanguageText } from "@/com_lib/common";

type SingleAddressProps = {
	t: TFunction, language: string,
	formik: any,
	fieldPrefix: string,
	countries: country[]
}
const SingleAddress: FC<SingleAddressProps> = (props) => {
	const t = props.t;
	const formik = props.formik;
	const fieldPrefix = props.fieldPrefix;

	return <>
		<Box sx={{ width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "12px", md: 0 }, alignItems: "flex-start", mb: "24px" }}>
			<Box sx={{ width: { xs: "100%", md: "calc(50% - 8px)" }, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('名字*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'firstName')}
				/>
			</Box>
			<Box sx={{ width: "16px", flexShrink: 0 }} />
			<Box sx={{ width: { xs: "100%", md: "calc(50% - 8px)" }, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('姓氏*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'lastName')}
				/>
			</Box>
		</Box>
		<Box sx={{ width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "12px", md: 0 }, alignItems: "flex-start", mb: "24px" }}>
			<Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('電話號碼*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'phone')}
				/>
			</Box>
		</Box>
		<Box sx={{ width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "12px", md: 0 }, alignItems: "flex-start", mb: "24px" }}>
			<Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('地址*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'address')}
				/>
			</Box>
		</Box>
		<Box sx={{ width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "12px", md: 0 }, alignItems: "flex-start", mb: "24px" }}>
			<Box sx={{ width: { xs: "100%", md: "calc(50% - 8px)" }, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('城市*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'city')}
				/>
			</Box>
			<Box sx={{ width: "16px", flexShrink: 0 }} />
			<Box sx={{ width: { xs: "100%", md: "calc(50% - 8px)" }, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('省/州*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'province')}
				/>
			</Box>
		</Box>
		<Box sx={{ width: "100%", display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: "12px", md: 0 }, alignItems: "flex-start", mb: "24px" }}>
			<FormControl sx={{ width: { xs: "100%", md: "calc(50% - 8px)" } }} >
				<Typography sx={{ fontSize: "14px", mt: "2px", mb: "4px" }}>
					{t('國家*')}
				</Typography>
				<MySelect className={generalStyle.oldStyleSelectNoLabel}
					MenuProps={{ className: generalStyle.selectPopupMenu }}
					{...formikForMySelect(formik, fieldPrefix + 'country')}
					renderValue={
						Boolean(formik.values?.[fieldPrefix + 'country']) ? undefined : () => t('請選擇國家')
					}
				>
					{
						props.countries.map(aCountry => {
							return <MenuItem value={aCountry.id} key={aCountry.id}>{getLanguageText(aCountry, 'name', props.language)}</MenuItem>
						})
					}
				</MySelect>
			</FormControl>
			<Box sx={{ width: "16px", flexShrink: 0 }} />
			<Box sx={{ width: { xs: "100%", md: "calc(50% - 8px)" }, display: "flex", flexDirection: "column", alignItems: "stretch" }}>
				<Typography sx={{ fontSize: "14px", mb: "4px" }}>
					{t('郵政編碼*')}
				</Typography>
				<TextField
					{...TextFieldNoLabelProps}
					{...formikForTextField(formik, fieldPrefix + 'postCode')}
				/>
			</Box>
		</Box>
	</>
}
export default memo(SingleAddress);